<template>
  <article class="bg-modal-bg">
    <div class="flex flex-col">
      <ContentCategoryBreadcrumbs
        v-if="variant?.category"
        :type="variant?.type"
        :categories="[ variant?.category ]"
      >
        <BackButton :route-code="ROUTES.CODE.NEWS" class-name="pr-5 lg:pr-10 text-light hover:underline" />
      </ContentCategoryBreadcrumbs>
      <div class="flex flex-col md:flex-row max-w-screen-xl" :style="{ 'margin-left': 'max(0px, calc(50vw - 640px))' }">
        <NewsDetailInfo :variant="variant" class="w-full" @select:tab:comments="selectTabComments" />
      </div>
      <CataloguePanel v-if="variant?.cataloguePosts?.length" :posts="variant.cataloguePosts" />
    </div>
  </article>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import BackButton from "@components/ui/back-button";
import NewsDetailInfo from "@components/news/news-details/news-detail-info";
import ContentCategoryBreadcrumbs from "@components/category/content-category-breadcrumbs";
import CataloguePanel from "@components/catalogue/catalogue-panel";

const props = defineProps({
  variant: {
    type: Object,
    default: () => { }
  }
})

const { $eventBus } = useNuxtApp();

const selectTabComments = (id) => {
  if (id === props.variant.id) {
    $eventBus.emit('focus:input', 'comment');
  }
}

</script>
